module.exports = __webpack_public_path__ + "img/jesse_davis.72df84ad.png";